"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var lodash_1 = __importDefault(require("lodash"));
var classnames_1 = __importDefault(require("classnames"));
var MobileActions = function (_a) {
    var isMobilePostViewIcon = _a.isMobilePostViewIcon, setIsMobilePostView = _a.setIsMobilePostView, setIsMobilePostViewIcon = _a.setIsMobilePostViewIcon, setOpenMobileSort = _a.setOpenMobileSort, setIsMobileSortIcon = _a.setIsMobileSortIcon, isMobileSortIcon = _a.isMobileSortIcon;
    var actions = [
        {
            icon: 'icon-ic-map2',
            show: isMobilePostViewIcon,
            handler: function () {
                setIsMobilePostView(false);
                setIsMobilePostViewIcon(false);
                setOpenMobileSort(false);
                setIsMobileSortIcon(false);
            },
        },
        {
            icon: 'icon-ic-sorting',
            show: isMobileSortIcon,
            handler: function () {
                setIsMobilePostView(true);
                setIsMobilePostViewIcon(false);
                setOpenMobileSort(true);
                setIsMobileSortIcon(false);
            },
        },
        {
            icon: 'icon-my-annoucements',
            show: !isMobilePostViewIcon || !isMobileSortIcon,
            handler: function () {
                setIsMobilePostView(true);
                setIsMobilePostViewIcon(true);
                setOpenMobileSort(false);
                setIsMobileSortIcon(true);
            },
        },
    ];
    return (react_1.default.createElement("ul", { className: classnames_1.default({
            'multiple-actions': isMobilePostViewIcon && isMobileSortIcon,
        }) }, actions
        .filter(function (action) {
        return lodash_1.default.isFunction(action.show)
            ? action.show()
            : action.show;
    })
        .map(function (action, index) {
        return (react_1.default.createElement("li", { key: index, onClick: action.handler },
            react_1.default.createElement("i", { className: action.icon })));
    })));
};
exports.default = react_1.memo(MobileActions);
